<template>
  <div class="page-container">
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-content">
        <h1 class="hero-title">
          Enabling <br />
          Smarter Decisions<br />
          for a Connected <br />
          Trade World
        </h1>
      </div>
      <div class="hero-globe">
        <div class="globe-container">
          <video class="globe-image" autoplay loop muted playsinline>
            <source
              :src="getCDNlink('assets/new-assets/About_Us_Banner.webm')"
              type="video/webm"
            />
          </video>
        </div>
      </div>
    </section>

    <!-- Our Story Section -->
    <firstComponent />

    <!-- Success Stories Section -->
    <section class="success-section">
      <div class="container" style="padding-top: 80px">
        <div class="section-label pink">Stories of Success</div>
        <h2 class="success-title">
          Impact Across Borders,<br />
          Outcomes Across Businesses
        </h2>
        <p class="success-subtitle">
          <span
            >Every successful trade transaction begins with trust, and trust
            begins with better information. At Credence, our impact is visible
            in every client that now moves faster, assesses risks smarter, and
            expands across borders with greater confidence.</span
          >
        </p>
        <p class="success-description">
          From remote exporters accessing international markets for the first
          time, to banks streamlining their counterparty due diligence — our
          stories of success span industries, geographies, and company sizes.
          We've helped
        </p>

        <div class="success-cards">
          <div class="success-card">
            <div class="card-icons">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <g clip-path="url(#clip0_2048_511)">
                  <path
                    d="M21.55 28H7.54999C7.28477 28 7.03042 27.8946 6.84288 27.7071C6.65534 27.5196 6.54999 27.2652 6.54999 27V9C6.54999 8.73478 6.65534 8.48043 6.84288 8.29289C7.03042 8.10536 7.28477 8 7.54999 8H17.55L22.55 13V27C22.55 27.2652 22.4446 27.5196 22.2571 27.7071C22.0696 27.8946 21.8152 28 21.55 28Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.55 8V5C10.55 4.73478 10.6553 4.48043 10.8429 4.29289C11.0304 4.10536 11.2848 4 11.55 4H21.55L26.55 9V23C26.55 23.2652 26.4446 23.5196 26.2571 23.7071C26.0696 23.8946 25.8152 24 25.55 24H22.55"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.55 19H17.55"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.55 23H17.55"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2048_511">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.549988)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <div class="card-icon-separator"></div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <g clip-path="url(#clip0_2048_438)">
                  <path
                    d="M16.95 10V16L21.95 19"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.94998 13H4.94998V8"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.39998 24C10.9724 25.4838 12.9473 26.4713 15.0778 26.8391C17.2083 27.207 19.3999 26.9388 21.3789 26.0682C23.3578 25.1976 25.0364 23.7631 26.2047 21.944C27.3731 20.1249 27.9795 18.0018 27.9482 15.8401C27.9168 13.6783 27.2491 11.5737 26.0285 9.7892C24.8079 8.00472 23.0885 6.6195 21.0851 5.80662C19.0817 4.99375 16.8833 4.78926 14.7643 5.21871C12.6454 5.64815 10.7 6.6925 9.17123 8.22124C7.69998 9.71124 6.48498 11.1162 4.94998 13"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2048_438">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.949982)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <h3>
              Banks accelerate their trade finance risk assessments from days to
              hours
            </h3>
          </div>

          <div class="success-card">
            <div class="card-icons">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <g clip-path="url(#clip0_2048_460)">
                  <path
                    d="M14.05 24C19.5729 24 24.05 19.5228 24.05 14C24.05 8.47715 19.5729 4 14.05 4C8.5272 4 4.05005 8.47715 4.05005 14C4.05005 19.5228 8.5272 24 14.05 24Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21.1213 21.0713L28.05 28"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2048_460">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.0500488)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <div class="card-icon-separator"></div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <g clip-path="url(#clip0_2048_471)">
                  <path
                    d="M16.4501 28C23.0775 28 28.4501 22.6274 28.4501 16C28.4501 9.37258 23.0775 4 16.4501 4C9.82266 4 4.45007 9.37258 4.45007 16C4.45007 22.6274 9.82266 28 16.4501 28Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21.4501 16C21.4501 24 16.4501 28 16.4501 28C16.4501 28 11.4501 24 11.4501 16C11.4501 8 16.4501 4 16.4501 4C16.4501 4 21.4501 8 21.4501 16Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.13257 12H27.7676"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.13257 20H27.7676"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2048_471">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.450073)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <h3>
              SMEs in remote markets get discovered and financed by global
              institutions
            </h3>
          </div>

          <div class="success-card">
            <div class="card-icons">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <g clip-path="url(#clip0_2048_484)">
                  <path
                    d="M16.55 16.1362V28.9962"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4.63757 9.61499L16.5501 16.135L28.4626 9.61499"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M28.03 22.8549L17.03 28.8774C16.8829 28.958 16.7178 29.0002 16.55 29.0002C16.3823 29.0002 16.2172 28.958 16.07 28.8774L5.07005 22.8549C4.91298 22.769 4.78186 22.6425 4.69039 22.4885C4.59892 22.3346 4.55046 22.159 4.55005 21.9799V10.0224C4.55046 9.84339 4.59892 9.66773 4.69039 9.51382C4.78186 9.3599 4.91298 9.23337 5.07005 9.14743L16.07 3.12493C16.2172 3.0444 16.3823 3.0022 16.55 3.0022C16.7178 3.0022 16.8829 3.0444 17.03 3.12493L28.03 9.14743C28.1871 9.23337 28.3182 9.3599 28.4097 9.51382C28.5012 9.66773 28.5496 9.84339 28.55 10.0224V21.9774C28.5501 22.1569 28.5018 22.3331 28.4103 22.4875C28.3188 22.6419 28.1875 22.7688 28.03 22.8549Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.7451 6.03882L22.5501 12.5001V19.0001"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2048_484">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.550049)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <div class="card-icon-separator"></div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <g clip-path="url(#clip0_2048_490)">
                  <path
                    d="M16.9501 28C23.5775 28 28.9501 22.6274 28.9501 16C28.9501 9.37258 23.5775 4 16.9501 4C10.3227 4 4.95007 9.37258 4.95007 16C4.95007 22.6274 10.3227 28 16.9501 28Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.4351 15.4074L12.1001 12.4999C12.188 12.3477 12.3144 12.2213 12.4667 12.1335C12.619 12.0458 12.7918 11.9997 12.9676 11.9999H15.0563C15.2252 12.0002 15.3913 11.9572 15.5388 11.8749L17.0751 11.0299C17.1426 10.9936 17.2053 10.9486 17.2613 10.8962L20.6263 7.85493C20.7937 7.70265 20.9046 7.49809 20.9407 7.27467C20.9768 7.05125 20.936 6.82219 20.8251 6.62493L19.5126 4.27368"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.42259 6.65381L7.95009 10.1351C7.85063 10.3707 7.84526 10.6356 7.93509 10.8751L9.37259 14.7088C9.43165 14.8654 9.5291 15.0048 9.65598 15.114C9.78287 15.2232 9.93515 15.2987 10.0988 15.3338L12.7776 15.9101C12.9262 15.9419 13.0655 16.0072 13.1851 16.101C13.3046 16.1948 13.4013 16.3146 13.4676 16.4513L13.9426 17.4351C14.0245 17.6041 14.1524 17.7466 14.3116 17.8463C14.4707 17.946 14.6548 17.9988 14.8426 17.9988H16.5676"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M27.5863 21.56L21.0388 17.5325C20.9197 17.46 20.787 17.4127 20.6488 17.3938L17.7963 17.0088C17.5821 16.9798 17.3642 17.021 17.1753 17.1262C16.9865 17.2315 16.8368 17.3951 16.7488 17.5925L15.0363 21.435C14.9567 21.6139 14.9313 21.8121 14.9633 22.0052C14.9953 22.1983 15.0833 22.3777 15.2163 22.5213L17.6838 25.0625C17.7908 25.1775 17.8691 25.3161 17.9126 25.4671C17.956 25.618 17.9633 25.777 17.9338 25.9313L17.5376 27.9863"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2048_490">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.950073)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <h3>
              Corporates strengthen supply chain visibility across complex,
              multi-country ecosystems
            </h3>
          </div>

          <div class="success-card">
            <div class="card-icons">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <g clip-path="url(#clip0_2048_497)">
                  <path
                    d="M17.0501 26.9999V3.99989C17.0499 3.81891 17.0007 3.64135 16.9076 3.48615C16.8146 3.33094 16.6811 3.20391 16.5215 3.11859C16.3619 3.03327 16.1821 2.99286 16.0013 3.00168C15.8206 3.01049 15.6456 3.06819 15.4951 3.16864L5.49505 9.83489C5.35789 9.9264 5.24548 10.0504 5.16784 10.1959C5.0902 10.3413 5.04974 10.5037 5.05005 10.6686V26.9999"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.05 11H26.05C26.3153 11 26.5696 11.1054 26.7572 11.2929C26.9447 11.4804 27.05 11.7348 27.05 12V27"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2.05005 27H30.05"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.05 14V16"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.05005 14V16"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.05005 21V23"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.05 21V23"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2048_497">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.0500488)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <div class="card-icon-separator"></div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <g clip-path="url(#clip0_2116_85)">
                  <path
                    d="M26.4501 5H22.4501C21.8978 5 21.4501 5.44772 21.4501 6V10C21.4501 10.5523 21.8978 11 22.4501 11H26.4501C27.0024 11 27.4501 10.5523 27.4501 10V6C27.4501 5.44772 27.0024 5 26.4501 5Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.4501 5H6.45007C5.89779 5 5.45007 5.44772 5.45007 6V10C5.45007 10.5523 5.89779 11 6.45007 11H10.4501C11.0024 11 11.4501 10.5523 11.4501 10V6C11.4501 5.44772 11.0024 5 10.4501 5Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M26.4501 21H22.4501C21.8978 21 21.4501 21.4477 21.4501 22V26C21.4501 26.5523 21.8978 27 22.4501 27H26.4501C27.0024 27 27.4501 26.5523 27.4501 26V22C27.4501 21.4477 27.0024 21 26.4501 21Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.4501 21H6.45007C5.89779 21 5.45007 21.4477 5.45007 22V26C5.45007 26.5523 5.89779 27 6.45007 27H10.4501C11.0024 27 11.4501 26.5523 11.4501 26V22C11.4501 21.4477 11.0024 21 10.4501 21Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8.45007 21V11"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21.4501 24H11.4501"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M24.4501 11V21"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.4501 8H21.4501"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2116_85">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0.450073)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <h3>
              Trade funds and investors uncover risks & hidden connections early
            </h3>
          </div>
        </div>

        <div
          class="team-section"
          :style="{
            '--bg-image': `url(${getCDNlink(
              'assets/new-assets/Statistics-BG.webp'
            )})`,
          }"
        >
          <p class="quote-text">
            For us, every report delivered is not just data
          </p>
          <h3 class="quote-highlight">
            It's a story of faster trade, smarter risk, and more connected
            global commerce.
          </h3>
        </div>
      </div>
    </section>

    <!-- Mission Section -->
    <section class="success-section">
      <div class="container">
        <div class="section-label pink">Our Mission</div>
        <h2 class="success-title">
          Accelerating<br />
          Borderless Trade <span class="text-blue">for everyone</span>
        </h2>
        <p class="success-description">
          At Credence, we believe that access to reliable information shouldn't
          be a privilege -<br />
          it should be a given. Our mission is to help every business - from
          global banks to emerging market SMEs.<br />
          Wherever businesses trade - Credence ensures they trade smarter.
        </p>

        <div class="mission-values">
          <div class="value-item">
            <div class="value-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <g clip-path="url(#clip0_2060_497)">
                  <path
                    d="M35.8331 21.1668C40.3331 16.6668 40.6144 11.3137 40.4738 8.92679C40.4504 8.563 40.2953 8.22018 40.0375 7.96241C39.7797 7.70464 39.4369 7.54956 39.0731 7.52617C36.6862 7.38554 31.3369 7.66304 26.8331 12.1668L15 23.9999L24 32.9999L35.8331 21.1668Z"
                    stroke="#C94374"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M25.5 13.5H13.9406C13.5433 13.5002 13.1623 13.658 12.8812 13.9387L6.44062 20.3794C6.24398 20.5765 6.10606 20.8244 6.0423 21.0954C5.97855 21.3664 5.99147 21.6498 6.07963 21.9138C6.16778 22.1779 6.32769 22.4122 6.54145 22.5906C6.75522 22.769 7.0144 22.8843 7.28999 22.9238L15 24"
                    stroke="#C94374"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M34.5 22.5V34.0594C34.4998 34.4567 34.342 34.8377 34.0613 35.1188L27.6206 41.5594C27.4235 41.756 27.1756 41.8939 26.9046 41.9577C26.6336 42.0214 26.3502 42.0085 26.0862 41.9204C25.8221 41.8322 25.5878 41.6723 25.4094 41.4585C25.231 41.2448 25.1157 40.9856 25.0763 40.71L24 33"
                    stroke="#C94374"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.73 35.2163C17.0044 36.8081 14.5594 40.5 7.5 40.5C7.5 33.4406 11.1919 30.9956 12.7838 30.27"
                    stroke="#C94374"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2060_497">
                    <rect width="48" height="48" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p>
              We exist to give access to dynamic intelligence that powers
              faster, smarter, and safer cross-border transactions.
            </p>
          </div>
          <div class="responsive-br"></div>
          <div class="value-item">
            <div class="value-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <g clip-path="url(#clip0_2048_599)">
                  <path
                    d="M25.5 33C32.9558 33 39 26.9558 39 19.5C39 12.0442 32.9558 6 25.5 6C18.0442 6 12 12.0442 12 19.5C12 26.9558 18.0442 33 25.5 33Z"
                    stroke="#C94374"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19.5 45H31.5"
                    stroke="#C94374"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M25.5 39V45"
                    stroke="#C94374"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M39 33.5719C35.3113 37.0661 30.4045 38.9825 25.3241 38.9133C20.2437 38.8441 15.3909 36.7947 11.7987 33.2014C8.20661 29.608 6.15885 24.7545 6.09138 19.6741C6.02391 14.5936 7.94205 9.68748 11.4375 6"
                    stroke="#C94374"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2048_599">
                    <rect width="48" height="48" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p>
              We exist to break down barriers in global trade by making data and
              insights accessible to all.
            </p>
          </div>
          <div class="responsive-br"></div>
          <div class="value-item">
            <div class="value-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <g clip-path="url(#clip0_2048_626)">
                  <path
                    d="M39.4232 39.4233C42.6546 36.1919 38.3688 26.6671 29.8508 18.1491C21.3327 9.63102 11.8079 5.34528 8.57657 8.57662C5.34523 11.808 9.63097 21.3327 18.149 29.8508C26.6671 38.3689 36.1919 42.6546 39.4232 39.4233Z"
                    stroke="#C94374"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M29.8508 29.8509C38.3688 21.3329 42.6546 11.8081 39.4232 8.57672C36.1919 5.34538 26.6671 9.63112 18.149 18.1492C9.63097 26.6673 5.34523 36.192 8.57657 39.4234C11.8079 42.6547 21.3327 38.369 29.8508 29.8509Z"
                    stroke="#C94374"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M24 26.25C25.2426 26.25 26.25 25.2426 26.25 24C26.25 22.7574 25.2426 21.75 24 21.75C22.7574 21.75 21.75 22.7574 21.75 24C21.75 25.2426 22.7574 26.25 24 26.25Z"
                    fill="#C94374"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2048_626">
                    <rect width="48" height="48" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p>
              We exist to level the playing field — so that geography, size, or
              data gaps don't limit opportunity.
            </p>
          </div>
        </div>

        <div
          class="mission-tagline"
          :style="{
            '--bg-image2': `url(${getCDNlink(
              'assets/new-assets/Statistics-BG.webp'
            )})`,
          }"
        >
          <h3>
            "Built for Trade,<br />
            powered by <span class="text-ai">AI</span>,<br />
            Focused on <span class="text-trust">Trust</span>"
          </h3>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import firstComponent from "@/components/AboutUs/firstComponent.vue";
import Footer from "@/components/HomePage/Footer/Footer.vue";
import config from "@/config";

export default {
  name: "CredencePage",
  components: {
    firstComponent,
    Footer,
  },
  mounted() {
    // Add any animations or interactions here
  },
  methods: {
    getCDNlink(fileKey) {
      let baseUrl = "";
      if (
        process.env.NODE_ENV === "development" ||
        process.env.NODE_ENV === "staging"
      ) {
        baseUrl = config.stagingCDN;
      } else if (process.env.NODE_ENV === "production") {
        baseUrl = config.prodCDN;
      }

      return `${baseUrl}${fileKey}`;
    },
  },
};
</script>

<style scoped>
/* Global Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.page-container {
  font-family: "Figtree";
  color: #1c1c1c;
  line-height: 1.6;
  /* position: relative; */
  /* top: -88px; */
}

.container {
  width: -webkit-fill-available;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 25px;
  margin-bottom: 88px;
  /* padding: 0 20px; */
}

/* Hero Section */
.hero-section {
  background-color: #1b1b1b;
  min-height: 100vh;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.hero-content {
  flex: 1;
  padding: 0px 0px 80px 160px;
  z-index: 2;
}

.hero-title {
  font-family: "Figtree";
  font-size: 68px;
  font-style: normal;
  font-weight: 500;
  line-height: 79.2px;
  letter-spacing: -1.44px;
  flex: 1 0 0;
  background: var(
    --Home-Banner-Title-Gradient,
    radial-gradient(
      58.47% 140.95% at 31.38% -13.87%,
      #fff 36%,
      #ffece0 64%,
      #72b4ff 88.94%
    )
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: left;
}

.text-blue {
  color: #4a90e2;
}

.hero-globe {
  /* flex: 1; */
  position: relative;
  width: 50%;
  height: 100vh;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.globe-container {
  width: -webkit-fill-available;
  /* height: -webkit-fill-available; */
  position: relative;
  aspect-ratio: 11/12;
}

.globe {
  width: 100%;
  height: 100%;
  background: radial-gradient(
      circle at 30% 30%,
      rgba(74, 144, 226, 0.3),
      transparent 50%
    ),
    radial-gradient(circle at 70% 70%, rgba(74, 144, 226, 0.2), transparent 50%);
  border-radius: 50%;
  position: relative;
  box-shadow: 0 0 100px rgba(74, 144, 226, 0.5);
}

.globe::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='600' height='600' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cpattern id='dots' x='0' y='0' width='20' height='20' patternUnits='userSpaceOnUse'%3E%3Ccircle cx='10' cy='10' r='1' fill='%234A90E2' opacity='0.5'/%3E%3C/pattern%3E%3C/defs%3E%3Ccircle cx='300' cy='300' r='280' fill='url(%23dots)' opacity='0.8'/%3E%3C/svg%3E");
  border-radius: 50%;
  animation: rotate 30s linear infinite;
}

.responsive-br {
  display: none;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Story Section */
.story-section {
  background: #e5eeff;
  padding: 80 160px 80 160px;
}

.section-label {
  display: inline-block;
  background: #ffffff;
  color: #c94374;
  padding: 8px 24px;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 500;
  /* margin-bottom: 24px; */
}

.section-label.pink {
  border: 1px solid #c94374;
  color: #c94374;
}

.story-content {
  display: flex;
  gap: 60px;
  align-items: center;
}

.story-text {
  flex: 1;
  background: #ffffff;
  padding: 40px;
  border-radius: 24px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.icon-wrapper {
  margin-bottom: 24px;
}

.story-description {
  font-size: 18px;
  line-height: 1.8;
  color: #1c1c1c;
}

.story-illustration {
  flex: 1;
}

.story-illustration img {
  width: 100%;
  height: auto;
  border-radius: 24px;
}

/* Success Section */
.success-section {
  background: #fff;
  padding: 0px 160px 80px 160px;
}

.success-title {
  text-align: center;
  font-family: "Figtree";
  font-size: 48px;
  font-style: normal;
  font-weight: 600;
  line-height: 56px;
  letter-spacing: 0.56px;
  background: var(
    --Section-Title-Gradient,
    linear-gradient(288deg, #046be1 19%, #224096 64%)
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.success-subtitle {
  color: var(--Raisin-Black, #1c1c1c);
  text-align: center;
  font-family: "Figtree";
  font-size: 24px;
  font-style: normal !important;
  font-weight: 400;
  line-height: 120%;
}

.success-description {
  color: var(--Raisin-Black, #1c1c1c);
  text-align: center;
  font-family: "Figtree";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -0.018px;
}

.success-cards {
  display: grid;
  gap: 10px;
  margin-bottom: 15px;
  width: -webkit-fill-available;
}

.success-card {
  background: var(
    --FAQ-Gradient,
    radial-gradient(71.02% 71.03% at 16.95% 16.51%, #0f0d43 0%, #1d1016 100%)
  );
  color: #ffffff;
  padding: 32px;
  border-radius: 16px;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
}

.card-icons {
  display: flex;
  width: fit-content;
  justify-content: center;
  align-items: center;
  border-radius: 9.6px;
  border: 1.2px solid var(--White, #fff);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.2) 0%,
    rgba(255, 255, 255, 0.1) 50%,
    rgba(255, 255, 255, 0) 100%
  );
}

.card-icons svg {
  margin: 14px;
}

.card-icon-separator {
  width: 1px;
  height: 100%;
  background-color: white;
}

.success-card h3 {
  color: var(--White, #fff);
  text-align: center;
  font-family: "Figtree";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  letter-spacing: -0.018px;
}

.team-section {
  display: flex;
  padding: 64px 80px;
  flex-direction: column;
  gap: 10px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid var(--Navbar-Gradient-Dark, #fff);
  background: var(--bg-image) lightgray 50% / cover no-repeat;
}

.team-photo {
  width: 100%;
  height: auto;
  display: block;
}

.quote-text {
  color: var(--White, #fff);
  text-align: center;
  font-family: "Figtree";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.48px;
}

.quote-highlight {
  color: var(--White, #fff);
  text-align: center;
  font-family: "Figtree";
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: -0.048px;
}

/* Mission Section */
.mission-section {
  background: #f0f4ff;
  padding: 100px 0;
}

.mission-title {
  font-size: clamp(36px, 4vw, 56px);
  font-weight: 600;
  color: #1b4f9b;
  margin-bottom: 24px;
  line-height: 1.2;
}

.mission-description {
  font-size: 18px;
  color: #1c1c1c;
  margin-bottom: 60px;
  text-align: center;
}

.mission-values {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  row-gap: 40px;
  /* margin-bottom: 80px; */
  margin-top: 15px;
  width: -webkit-fill-available;
}

.value-item {
  display: flex;
  padding: 32px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex: 1 0 0;
  align-self: stretch;
}

.value-item:first-child {
  border-right: 1px solid #eef1ff;
}

.value-item:nth-child(3) {
  border-right: 1px solid #eef1ff;
}

.value-icon {
  width: fit-content;
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 10px;
  border-radius: 40px;
  border: 1px solid var(--Secondary---French-Rose, #c94374);
}

.value-item p {
  color: var(--Raisin-Black, #1c1c1c);
  text-align: center;
  font-family: "Figtree";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -0.018px;
  margin: 0 2rem;
}

.mission-tagline {
  width: -webkit-fill-available;
  background: #1c1c1c;
  background-image: var(--bg-image2);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  padding: 80px;
  border-radius: 24px;
  text-align: center;
  min-height: 500px;
  align-content: center;
}

.mission-tagline h3 {
  text-align: center;
  font-family: "Figtree";
  font-size: 68px;
  font-style: normal;
  font-weight: 500;
  line-height: 79.2px;
  letter-spacing: -1.44px;
  background: radial-gradient(
    82.47% 140.95% at 31.38% -13.87%,
    #fff 36%,
    #ffece0 64%,
    #046be1 81%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.text-ai {
  color: #4a90e2;
  font-weight: 400;
}

.text-trust {
  color: #4a90e2;
  font-weight: 400;
}

.globe-image {
  position: absolute;
  top: 0;
  right: 0%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* background-blend-mode: overlay; */
  /* filter: blur(1.399999976158142px); */
}

.globe-image::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(0deg, #046be1 0%, #046be1 100%);
  background-blend-mode: overlay;
  filter: blur(1.399999976158142px);
  opacity: 0.8;
  z-index: 1;
}

/* 2x2 grid layout between 767px and 1156px */
@media screen and (min-width: 767px) and (max-width: 1156px) {
  .success-cards {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }

  .hero-content {
    padding: 0px 0px 80px 40px;
  }

  .story-section {
    padding: 80px 80px;
  }

  .story-title {
    font-size: 32px;
    line-height: 50px;
  }

  .success-section {
    padding: 0px 80px 80px 80px;
  }

  .success-title {
    font-size: 36px;
  }

  .quote-highlight {
    line-height: 100%;
    font-size: 38px;
  }

  .quote-text {
    font-size: 18px;
  }

  .container {
    margin-bottom: 0;
  }

  .mission-values {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }

  .value-item {
    padding: 20px;
  }

  .value-icon svg {
    width: 35px;
    height: 35px;
  }

  .value-icon {
    padding: 10px;
  }

  .value-item p {
    font-size: 16px;
    margin: 0;
  }

  .mission-tagline {
    min-height: 350px;
    padding: 50px;
  }
}

/* Default layout above 1156px */
@media screen and (min-width: 1156px) {
  .success-cards {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .success-section {
    padding: 0 20px 0 20px;
  }
  .story-section {
    padding: 40px 20px;
  }
  .success-cards {
    grid-template-columns: 1fr;
  }
  .hero-section {
    flex-direction: column;
    text-align: center;
  }

  .hero-content {
    padding: 100px 20px 40px 20px;
  }

  .hero-globe {
    width: -webkit-fill-available;
    height: 100%;
  }

  .globe-container {
    width: 90%;
    aspect-ratio: 12 / 9;
  }

  .story-content {
    flex-direction: column;
  }

  .success-cards {
    grid-template-columns: 1fr;
  }

  .mission-values {
    grid-template-columns: 1fr;
    row-gap: 30px;
  }

  .quote-highlight {
    font-size: 28px;
    line-height: 120%;
    letter-spacing: -0.021px;
  }

  .value-item {
    border: none !important;
    padding: 0;
  }

  .hero-section {
    min-height: auto;
  }

  .hero-title {
    font-size: 48px;
    line-height: 56px;
  }

  .success-title {
    font-size: 32px;
    line-height: 35px;
  }

  .success-subtitle {
    font-size: 18px;
    line-height: 150%;
  }

  .success-description {
    font-size: 16px;
    letter-spacing: -0.016px;
  }
  .card-icons svg {
    width: 28px;
    height: 28px;
    margin: 10px;
  }

  .success-card h3 {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: -0.016px;
  }

  .success-card {
    min-height: auto !important;
  }

  .team-section {
    padding: 25px;
    gap: 0;
  }

  .quote-text {
    font-size: 18px;
  }

  .container {
    padding: 40px 0;
    margin: 0;
  }

  .value-icon svg {
    width: 32px;
    height: 32px;
  }

  .value-icon {
    padding: 10px;
  }

  .value-item p {
    font-size: 16px;
    letter-spacing: -0.016px;
  }

  .responsive-br {
    display: block;
    width: 100%;
    height: 1px;
    background: linear-gradient(180deg, #e4efff 0%, #eef1ff 100%);
  }

  .mission-tagline {
    padding: 20px;
    min-height: auto;
  }

  .mission-tagline h3 {
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 0.56px;
  }
}
@media (max-width: 480px) {
  .success-title {
    font-size: 36px;
  }
  .success-subtitle {
    font-size: 16px;
    line-height: 150%;
  }
}
</style>
